<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Monthly Donation">
            <div>
              <div>
    <div>
      <div class="styled-radio-container styled-radio-container--ou-donation row">
        <div class="radio-part">
          <input
          name="payment"
            id="oneTime"
            type="radio"
            class="frequency"
            :checked="!monthly && getValue('amount') === '1000'"
            @click="
              setValue('dayOfMonth', null);
              setValue('periodMonths', null);
              setValue('amount', '1000');
            "
          />
          <FormLabel for="oneTime">
          <div class="money_format label-amount">$1,000</div>
           <span class="label-description">Single Donation</span></FormLabel>
        </div>
        <div class="radio-part">
          <input
          name="payment"
            id="monthly"
            type="radio"
            class="frequency"
            :checked="monthly && getValue('amount') === '83.33'"
            @click="
              setValue('dayOfMonth', '' + new Date().getDate());
              setValue('amount', '83.33');
              setValue('periodMonths', '12');
            "
          />
          <FormLabel for="monthly">
            <div class="money_format label-amount">$83.33</div>
           <span class="label-description"> Monthly Donation</span>

          </FormLabel>
        </div>
      </div>
    </div>
    <FormRow class="monthly-note" v-if="monthly">
      <div>
        Your donation will be made today and on the <strong>{{ monthDay }}</strong> of
        each following month using the payment method selected. You may change or cancel
        this amount at any time. <br /><br />
      </div>
    </FormRow>
  </div>
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Personal Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Spouses Details">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label"> First </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.spouseFirstName"
                />
              </div>
              <div style="width: 100%">
                <FormLabel class="control-label"> Last </FormLabel>
                <FormInput type="text" class="width-full" field="custom.spouseLastName" />
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label">
                  How did you hear about the Ignite Society?
                </FormLabel>
                <FormInput type="textarea" class="width-full" field="custom.hearAboutUs" />
              </div>
            </FormRow>
            <InHonorOf />
          </FormSection>          
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Designation">
            <FormLabel class="control-label" style="margin-bottom: 10px">
              Would you like your donation to be directed towards a specific region or
              department?
            </FormLabel>
            <NcsyIgniteDesignation />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, getValue, form, submit } = usePaymentForm();

    
    return {
      form,
      submit,
      monthly: computed(() => !!form.value.dayOfMonth),
      getValue,
      setValue,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!;

        const j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      }),
      setDailyDate(date: Date) {
        setValue(
          "custom.birthdate",
          new Date(
            Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
          ).toISOString()
        )
      },
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .form-container.ou-donation-form {
  margin: 20px auto 20px !important;
  padding: 16px !important;

  @media (min-width: 720px) {
    margin: 20px auto !important;
    padding: 20px !important;
    border-radius: 10px !important;
  }
}

::v-deep.styled-radio-container.styled-radio-container--ou-donation.row {

margin: 0 0 5px 0px;
display: flex;
flex-wrap: wrap;
width: 100%;
gap: 16px;

label {
  cursor: pointer;
  height: 100%;
  width: 100%;
  padding: 32px 46px;
  border-radius: 8px;
border: 2px solid  #EEEFF0;
background: #FFF;
  &:hover {
    background: #fafafa;
  }
  @media only screen and (max-width: 500px) {
    padding: 10px 14px;
  }
}
input {
  height: 0;
  top: 20px;
  position: absolute;
  left: 20px;
  z-index: -1;
  visibility: hidden;
}
.money_format{
  color: #1F262E;
text-align: center;
font-size: 24px;
font-style: normal;
padding-bottom: 10px;
font-weight: 700;
line-height: 24px; 
text-transform: capitalize;
}
  .label-description {
  color: #9FA4AA;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  }
input[type="radio"]:checked + label {
  border: 2px solid #1e50b4;
  .money_format {
    color: #1e50b4;
  }
  .label-description {
    color: #080f16;
  }
}
}

.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}
</style>
